var _path, _path2, _rect, _rect2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.266,18.197l-3.487-6.986c-.612-1.227-1.866-2.002-3.237-2.002H12.459c-1.371,0-2.625.775-3.237,2.002l-3.487,6.986c-.557,1.116-.847,2.347-.847,3.595v13.598c0,1.644,1.333,2.977,2.977,2.977s2.977-1.333,2.977-2.977v-.84h20.319v.84c0,1.644,1.333,2.977,2.977,2.977s2.977-1.333,2.977-2.977v-13.598c0-1.248-.29-2.479-.847-3.595Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.026,12.438h15.948c.684,0,1.305.402,1.586,1.026l2.894,6.436c.248.552-.156,1.176-.761,1.176H9.307c-.605,0-1.009-.624-.761-1.176l2.894-6.436c.281-.624.901-1.026,1.586-1.026Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.977,
    y: 25.086,
    width: 8.788,
    height: 3.181,
    rx: 1.59,
    ry: 1.59
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.235,
    y: 25.086,
    width: 8.788,
    height: 3.181,
    rx: 1.59,
    ry: 1.59
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.038,3.633h8.301c1.37,0,2.482,1.112,2.482,2.482v3.094h-13.264v-3.094c0-1.37,1.112-2.482,2.482-2.482Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.275,
    y1: 6.421,
    x2: 18.102,
    y2: 6.421
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTaxi);
export default __webpack_public_path__ + "static/media/indoor-taxi.166ec49567426fae4418c41602cead6b.svg";
export { ForwardRef as ReactComponent };